import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/landingData";
import { ArrowLeft } from "lucide-react";

export function LegalShell({ title, updated, children }) {
  return (
    <div className="relative z-10 min-h-screen px-5 py-14 sm:py-20">
      <div className="pointer-events-none absolute -left-40 top-0 h-[420px] w-[420px] glow-violet blur-3xl opacity-25" />
      <div className="pointer-events-none absolute -right-40 bottom-0 h-[420px] w-[420px] glow-orange blur-3xl opacity-20" />

      <div className="mx-auto max-w-3xl">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 text-sm text-white/60 transition-colors hover:text-white"
          data-testid="legal-back-home">
          <ArrowLeft className="h-4 w-4" /> Back to b→come
        </Link>

        <div className="mb-10 flex items-center gap-4">
          <img src={LOGO_URL} alt="b→come" className="h-10 w-auto" />
          <div>
            <h1 className="font-mega text-3xl text-white sm:text-4xl" data-testid="legal-title">{title}</h1>
            <p className="mt-1 text-xs uppercase tracking-widest text-white/40">Last updated: {updated}</p>
          </div>
        </div>

        <article
          className="prose prose-invert max-w-none rounded-3xl border border-white/10 bg-[#0A0A0C]/70 p-8 sm:p-10
                     [&_h2]:mt-8 [&_h2]:font-nunito [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-white
                     [&_h3]:mt-6 [&_h3]:font-nunito [&_h3]:text-base [&_h3]:font-bold [&_h3]:text-white/90
                     [&_p]:mt-3 [&_p]:text-sm [&_p]:leading-relaxed [&_p]:text-white/70
                     [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-6 [&_ul]:text-sm [&_ul]:text-white/70
                     [&_a]:text-gold [&_a]:underline-offset-4 hover:[&_a]:underline
                     [&_strong]:text-white [&_code]:rounded [&_code]:bg-white/10 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:text-white">
          {children}
        </article>

        <div className="mt-8 text-center text-xs text-white/40">
          Questions? Email <a href="mailto:hello@b-come.ai" className="text-gold hover:underline">hello@b-come.ai</a>
        </div>
      </div>
    </div>
  );
}
